import { filter } from 'lodash';

/**
 * POM-5906/5907: the facility transfer pickers must only offer destinations the backend will
 * actually accept. The authoritative gate lives server-side in
 * rxOrderService.transferOrderFulfillingPharmacy, which requires the destination to be a live
 * DISPENSING_PHARMACY and rejects a 503A compounding facility with
 * TRANSFER_DESTINATION_NOT_ELIGIBLE.
 *
 * This filter is a UX affordance ONLY — it stops an operator from choosing an option that is
 * guaranteed to fail. It is NOT the eligibility gate and must never be treated as one.
 *
 * It deliberately mirrors exactly one backend predicate and no more:
 *   - pharmacy_type = DISPENSING_PHARMACY  -> checked here
 *   - is_active = true / is_deleted = false -> already enforced by getFulfillingPharmacies
 *   - fulfillment_mode                      -> NOT checked, because the gate does not check it
 * Filtering on anything else would hide facilities the server would happily accept.
 */
export const PHARMACY_TYPE = {
  DISPENSING_PHARMACY: 'DISPENSING_PHARMACY',
};

/**
 * Fail-closed: a missing or unrecognized pharmacyType is treated as not dispensing, matching the
 * backend's strict equality check (where NULL also fails).
 */
export const isDispensingPharmacy = (facility) =>
  facility?.pharmacyType === PHARMACY_TYPE.DISPENSING_PHARMACY;

/**
 * Transfer destinations for a picker: dispensing facilities only, minus the order's own facility
 * when one is supplied. Bulk transfer spans many orders, so it passes no exclusion.
 */
export const selectTransferDestinations = (facilities, { excludeFacilityId } = {}) =>
  filter(
    facilities,
    (facility) =>
      isDispensingPharmacy(facility) &&
      (!excludeFacilityId || facility?.fulfillingPharmacyId !== excludeFacilityId)
  );
